import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import thunkMiddleware from 'redux-thunk'
import { createLogger } from 'redux-logger'
import { createStore, applyMiddleware} from 'redux'
import App from './components/App'
import reducers from './reducers'
import injectTapEventPlugin from 'react-tap-event-plugin'
import registerServiceWorker from './registerServiceWorker'

injectTapEventPlugin();
const logger = createLogger();
const store = createStore(reducers,
	applyMiddleware(
		thunkMiddleware, logger
	)
)

ReactDOM.render(
		<Provider store={store}>
			<App />
		</Provider>,
	document.getElementById('root')
);
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js